import './wdyr'; // <--- first import

import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./assets/fonts/WorkSans-VariableFont_wght.ttf";

ReactDOM.render(<App />, document.getElementById("root"));
